import { render, staticRenderFns } from "./into-logistick-check.vue?vue&type=template&id=49b99a23&"
import script from "./into-logistick-check.vue?vue&type=script&lang=ts&"
export * from "./into-logistick-check.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports